// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsInboundAddress } from './clsInboundAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClsInboundPrescriber {
    'firstName'?: string;
    'lastName'?: string;
    'officePhone'?: string;
    'npi'?: string;
    'status'?: string;
    'accountType'?: string;
    'specialistType'?: string;
    'tC_OfficeContactName__c'?: string;
    'fax'?: string;
    'prescriberAddress'?: Array<ClsInboundAddress>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClsInboundPrescriber>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "officePhone",
            "baseName": "officePhone",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "string"
        },
        {
            "name":     "accountType",
            "baseName": "accountType",
            "type":     "string"
        },
        {
            "name":     "specialistType",
            "baseName": "specialistType",
            "type":     "string"
        },
        {
            "name":     "tC_OfficeContactName__c",
            "baseName": "tC_OfficeContactName__c",
            "type":     "string"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "prescriberAddress",
            "baseName": "prescriberAddress",
            "type":     "Array<ClsInboundAddress>"
        },
    ];

    static getAttributeTypeMap() {
        return ClsInboundPrescriber.attributeTypeMap;
    }
}
